<template>
    <div>
        <label :for="id" class="block text-sm font-medium text-gray-700">
            <slot v-if="headline"></slot>
        </label>
        <div class="mt-1">
            <input v-bind:value="value"
                   :id="id"
                   :type="type"
                   v-on:input="$emit('input', $event.target.value)"
                   class="form-input shadow-sm focus:ring-secondary focus:border-secondary block w-full sm:text-sm border-gray-300 rounded-md"
                   :placeholder="defaultSlot"
                   :class="{'border-red-500 bg-red-100': hasError}"
            />
        </div>
        <p class="mt-2 text-sm text-gray-500" v-if="hasHelperSlot">
            <slot name="helper"></slot>
        </p>
    </div>
</template>

<script>
import uniqueId from "lodash/uniqueId";

export default {
    name: "InputText",

    props: {
        value: {},
        hasError: {},
        type: {
            default: 'text',
        },
        headline: {
            default: true,
        },
    },

    data: () => ({
        id: uniqueId(),
    }),

    computed: {
        hasHelperSlot() {
            return !!this.$slots['helper'];
        },
        defaultSlot() {
            return this.$slots && this.$slots['default'] ? this.$slots['default'][0]?.text?.trim() : "";
        },
    },

}
</script>

<style scoped>

</style>
